import { render, staticRenderFns } from "./UploadBox.vue?vue&type=template&id=d98a7f9c&scoped=true"
import script from "./UploadBox.vue?vue&type=script&lang=js"
export * from "./UploadBox.vue?vue&type=script&lang=js"
import style0 from "./UploadBox.vue?vue&type=style&index=0&id=d98a7f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98a7f9c",
  null
  
)

export default component.exports